import client from "../libs/HttpClient";

class TopicItemServices {
  static topicitemList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/topicItem?page=${page_no}`, request);
  }
  static addTopicItem(request) {
    return client.post(`/add-topicitem`, request, {});
  }
  static updateTopicItem(request) {
    return client.post(`/edit-topicitem`, request, {});
  }
  static viewTopicItem(params) {
    return client.get(`get-topic-item`, { params });
  }
  static deleteTopicItem(params) {
    return client.delete(`delete-topicitem`, { params });
  }
  static getTopicList(request) {
    return client.get(`get-topic-list`, request);
  }
}
export { TopicItemServices };
